import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/security-policy.scss';

initMainHeader();
